<skitbs-template>

    <div class="TexAlRight FontBold PadT">
        <a (click)="router.navigate(['/orders'])">
            <i class="pi pi-times-circle FontBold Green" style="margin-right: 30px; font-size: xx-large"></i>
        </a>
    </div>

    <div class="d-flex-stretch BsFsSmaller" style="margin: 12px 0 0 4px;">

        <div style="width: 10px; min-height: 55px; border-radius: 8px 0 0 8px;" class="GreenBack"></div>
        <div class="d-col WhiteBack MarR OrderCard">

            <div class="d-flex">
                <!-- menu image -->
                <div *ngIf="modelMenuXBVO.imageUrl">
                    <img src="{{modelMenuXBVO.imageUrl}}" [width]="106" [height]="72" class="MarR" style="border-radius: 8px;" (error)="handleMissingImage($event)"/>
                </div>
                <!-- menu names -->
                <div class="d-col">
                    <div class="BsFsLarge PadT"><b>{{modelMenuName1}}</b></div>
                    <div class="BsFsMedium">{{modelMenuName2}}</div>
                </div>
            </div>
            <div class="EmptyBox5"></div>


            <div class="MarT BsFsSmaller">{{v('mealType')}}: {{modelPlaceholderXBVO.mealType}}</div>
            <div class="">{{'menuLine'}}: {{modelPlaceholderXBVO.menuLineDesignation}}</div>
            <div class="EmptyBox20"></div>

            <!-- allergens -->
            <allergens [modelRows]="modelMenuXBVO.allergen"></allergens>

            <!-- additives -->
            <additives [modelRows]="modelMenuXBVO.additive"></additives>

            <!-- nutritions. -->
            <nutritions [modelNutritions]="modelMenuXBVO.nutritions"></nutritions>

            <!-- menu-components -->
            <menu-components [modelComponents]="modelMenuXBVO.component"></menu-components>





            <div class="EmptyBox20"></div>

        </div>

    </div>


</skitbs-template>